import React from "react";
import { AnimatePresence } from "framer-motion";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import { ETAPA_LABELS } from "../../../utils/toc/etapas";
import {
  BannerCloseBtn,
  BannerStrong,
  BannerWrapper,
} from "./styles";

export default function BannerMudancaGargalo({
  visivel,
  mudanca,
  onDispensar,
}) {
  return (
    <AnimatePresence>
      {visivel && mudanca && (
        <BannerWrapper
          role="status"
          aria-live="polite"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
        >
          <FiAlertTriangle size={20} aria-hidden />
          <span>
            Gargalo migrou de{" "}
            <BannerStrong>
              {mudanca.de ? ETAPA_LABELS[mudanca.de] : "—"}
            </BannerStrong>{" "}
            para{" "}
            <BannerStrong>{ETAPA_LABELS[mudanca.para]}</BannerStrong>. Acione o
            playbook de {ETAPA_LABELS[mudanca.para]} e revise as cordas.
          </span>
          <BannerCloseBtn
            type="button"
            aria-label="Marcar como lido"
            onClick={onDispensar}
          >
            <FiX size={14} />
          </BannerCloseBtn>
        </BannerWrapper>
      )}
    </AnimatePresence>
  );
}
